import {Suspense} from "react"
import {Route, Routes} from "react-router-dom"
import PUBLIC_ROUTES from "./publicRoutes"

const Router = () => {
    return (
        <Suspense fallback={<div/>}>
            <Routes>
                {
                    PUBLIC_ROUTES.map(
                        route => <Route key={route.name} path={route.path} element={route.Component} exact={route.exact}/>
                    )
                }
            </Routes>
        </Suspense>

    );
};

export default Router;